export default __webpack_public_path__ + "static/nyan-cat-f945e264c6f7a23cef8352f52f7b8703.png";